import React from 'react';
import { Container } from 'react-bootstrap';
import PageHeading from './PageHeading';

function RefundPolicyPage() {
  return (
    <Container className="Center-column legal-page">
      <div className="pg-break"> </div>
      <PageHeading icon="return">Refund Policy</PageHeading>
      <div className="legal-content">
        <p className="legal-updated">Last updated: September 19, 2026</p>

        <h2>Overview</h2>
        <p>
          At Nature&apos;s Nefer, we want you to feel confident in every
          purchase. If something is not right with your order, we are here to
          help.
        </p>

        <h2>Eligibility</h2>
        <p>
          You may request a refund or exchange within 30 days of the delivery
          date if:
        </p>
        <ul>
          <li>The product arrived damaged or defective</li>
          <li>You received the wrong item</li>
          <li>The product is unused and in its original packaging</li>
        </ul>
        <p>
          Opened or used products may not be eligible for a refund for hygiene
          reasons, except when the item is defective or we made an error.
        </p>

        <h2>How to Request a Refund</h2>
        <p>
          Contact us with your order number, a brief description of the issue,
          and photos if the product was damaged or incorrect. We will review
          your request and reply with next steps, including return shipping
          instructions when needed.
        </p>

        <h2>Processing</h2>
        <p>
          Once we receive and inspect a returned item, approved refunds are
          issued to the original payment method. Please allow several business
          days for the refund to appear, depending on your bank or card issuer.
        </p>

        <h2>Shipping Costs</h2>
        <p>
          If the return is due to our error or a defective product, we cover
          return shipping. For other eligible returns, the customer is
          responsible for return shipping costs unless we state otherwise.
        </p>

        <h2>Questions</h2>
        <p>
          If you have questions about a recent order or this policy, reach out
          through our site contact options and we will gladly assist.
        </p>
      </div>
    </Container>
  );
}

export default RefundPolicyPage;
